export enum OcpsPolicyFeature {
    Privacy = 'privacy',
    UnifiedInbox = 'unifiedInbox',
    KeyboardStyles = 'keyboardStyles',
    AlwaysShowBcc = 'alwaysShowBcc',
    Presence = 'presence',
}

export enum PrivacyPolicySettingId {
    OptionalConnectedExperiences = 'office16;L_OptionalConnectedExperiences',
    ConnectedOfficeExperiences = 'office16;L_ConnectedOfficeExperiences',
    // Beware of the typo "Anlayzing" — this is how the server stores it
    OfficeExperiencesAnalyzingContent = 'office16;L_OfficeExperiencesAnlayzingContent',
    OfficeExperiencesDownloadingContent = 'office16;L_OfficeExperiencesDownloadingContent',
}

export enum UnifiedInboxPolicySettingId {
    ShowAllAccountsView = 'outlooknew;L_ShowAllAccountsView;L_ShowAllAccountsView',
    ShowAllAccountsViewUserOverride = 'outlooknew;L_ShowAllAccountsView;L_ShowAllAccountsViewUserOverride',
}

export enum KeyboardStylesPolicySettingId {
    EnableKeytips = 'outlooknew;L_KeyboardStyles;L_EnableKeytips',
    OutlookWebKeyboardShortcutStyle = 'outlooknew;L_KeyboardStyles;L_WebKeyboardShortcutStyle',
    OutlookWindowsKeyboardShortcutStyle = 'outlooknew;L_KeyboardStyles;L_WindowsKeyboardShortcutStyle',
    KeyboardStylesUserOverride = 'outlooknew;L_KeyboardStyles;L_KeyboardStylesUserOverride',
}

export enum AlwaysShowBccPolicySettingId {
    AlwaysShowBccOptions = 'outlooknew;L_AlwaysShowBcc;L_AlwaysShowBccOptions',
    AlwaysShowBccUserOverride = 'outlooknew;L_AlwaysShowBcc;L_AlwaysShowBccUserOverride',
}

export enum PresencePolicySettingId {
    TurnOffPresenceIntegration = 'office16;L_TurnOffPresenceIntegration',
    ConfigurePresenceIcons = 'office16;L_ConfigurePresenceIcons;L_ConfigurePresenceIconsDropID',
}

export type FeatureSettingIdMap = {
    [OcpsPolicyFeature.Privacy]: PrivacyPolicySettingId;
    [OcpsPolicyFeature.UnifiedInbox]: UnifiedInboxPolicySettingId;
    [OcpsPolicyFeature.KeyboardStyles]: KeyboardStylesPolicySettingId;
    [OcpsPolicyFeature.AlwaysShowBcc]: AlwaysShowBccPolicySettingId;
    [OcpsPolicyFeature.Presence]: PresencePolicySettingId;
};

export type OutlookCloudPolicySettingId = FeatureSettingIdMap[OcpsPolicyFeature];

export const FeatureToAllowUserOverrideSettingIdMap: Partial<
    Record<OcpsPolicyFeature, OutlookCloudPolicySettingId>
> = {
    [OcpsPolicyFeature.UnifiedInbox]: UnifiedInboxPolicySettingId.ShowAllAccountsViewUserOverride,
    [OcpsPolicyFeature.KeyboardStyles]: KeyboardStylesPolicySettingId.KeyboardStylesUserOverride,
    [OcpsPolicyFeature.AlwaysShowBcc]: AlwaysShowBccPolicySettingId.AlwaysShowBccUserOverride,
};
